/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1SeasonperiodsQueryResponse } from '../../types/GetV1Seasonperiods.ts'

export const getV1SeasonperiodsQueryKey = () => [{ url: '/v1/SeasonPeriods' }] as const

export type GetV1SeasonperiodsQueryKey = ReturnType<typeof getV1SeasonperiodsQueryKey>

/**
 * {@link /v1/SeasonPeriods}
 */
export async function getV1Seasonperiods(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1SeasonperiodsQueryResponse, ResponseErrorConfig<Error>, unknown>(
        { method: 'GET', url: `/v1/SeasonPeriods`, ...requestConfig },
    )
    return res
}

export function getV1SeasonperiodsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1SeasonperiodsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1SeasonperiodsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1SeasonperiodsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Seasonperiods(config)
        },
    })
}

/**
 * {@link /v1/SeasonPeriods}
 */
export function useGetV1Seasonperiods<
    TData = ResponseConfig<GetV1SeasonperiodsQueryResponse>,
    TQueryData = ResponseConfig<GetV1SeasonperiodsQueryResponse>,
    TQueryKey extends QueryKey = GetV1SeasonperiodsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1SeasonperiodsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1SeasonperiodsQueryKey()

    const query = useQuery(
        {
            ...getV1SeasonperiodsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
